export default "__VITE_ASSET__986ff325__"